import Vue from 'vue';
import Vuex from 'vuex';
import state from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
// Modules
import auth from '../modules/auth/';


Vue.use(Vuex);

export default new Vuex.Store({
    state,
    actions,
    mutations,
    getters,
    modules: {
        auth,
    },
});



// WEBPACK FOOTER //
// ./src/store/index.js